import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    friendlyName: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired
  })
);
